import { render, staticRenderFns } from "./AddCPT.vue?vue&type=template&id=76d5742a&scoped=true&"
import script from "./AddCPT.vue?vue&type=script&lang=js&"
export * from "./AddCPT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5742a",
  null
  
)

export default component.exports